
	import { Component, Vue } from 'vue-property-decorator';
	import aps from '@/HostApp/store/ApsModules/ApsModule';
	import { serverProps } from '@/Common/Environment/const';

	@Component({
		components: {}
	})
	//todo avb move to vue default template
	export default class GlobalLoading extends Vue {
		protected get loading(): boolean {
			return this.vueWorkspace && this.showGlobalLoading;
		}

		protected get showGlobalLoading(): boolean {
			return aps.apsc.showGlobalLoading;
		}

		protected get vueWorkspace(): boolean {
			return aps.navigation.isVueWorkspace;
		}

		protected get computedStyle(): Partial<CSSStyleDeclaration> {
			//todo avb get values from DesignTokens Module in runtime
			const headerHeight = 72;
			const bannerHeight = 40;
			const hasBanner = !!serverProps.breadcrumbs?.impersonatedWarning;

			const offset = `${hasBanner ? headerHeight + bannerHeight : headerHeight}px`;

			return {
				top: offset,
				height: `calc(100vh - ${offset})`,
				position: 'sticky',
				gridColumnStart: '2',
				gridColumnEnd: '3',
				gridRowStart: 'alerts',
				gridRowEnd: 'padding'
			};
		}
	}
